import { render, staticRenderFns } from "./AddPackageToUserModal.vue?vue&type=template&id=65b207e7"
import script from "./AddPackageToUserModal.vue?vue&type=script&lang=js"
export * from "./AddPackageToUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports